import onePlusNordCE5 from '../../assets/OnePlus/OnePlusNordCE/OnePlusNordCE5.png';
import onePlusNord5 from '../../assets/OnePlus/OnePlusNord5/OnePlusNord5.png';
import onePlus15s from '../../assets/OnePlus/OnePlus15S/OnePlus15s.png';
import onePlus15 from '../../assets/OnePlus/OnePlus15/OnePlus15.png';
import onePlusPadGo2 from '../../assets/OnePlus/OnePlusPad/PadGo2/Go2.png';
import onePlusPadLite from '../../assets/OnePlus/OnePlusPad/PadLite/Lite.png';

const onePlusData = [
  {
    id: 1,
    title: 'OnePlus Nord CE5 (128GB)',
    productImage: onePlusNordCE5,
    images: [onePlusNordCE5],
    originalPrice: '28,999',
    discountedPrice: '28,999',
    colors: ['Marble Mist', 'Black Infinity', 'Nexus Blue'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        'Dimensity 8350 Apex processor',
        '12GB next-gen LPDDR5X RAM',
        '128GB ROM',
      ],
      Battery: [
        '7100mAh graphene-reinforced battery',
        'OnePlus\'s biggest battery ever',
        'All-day battery life',
      ],
      Camera: [
        '50MP Sony LYT-600 with OIS',
        '8MP Ultra Wide-angle',
        'Flagship camera system',
      ],
      Display: [
        'AMOLED display',
        '120Hz refresh rate',
        'Ultra HDR support',
        'Dream screen experience',
      ],
      Storage: [
        '8GB RAM + 128GB ROM',
      ],
    },
  },
  {
    id: 2,
    title: 'OnePlus Nord CE5 (256GB)',
    productImage: onePlusNordCE5,
    images: [onePlusNordCE5],
    originalPrice: '30,999',
    discountedPrice: '30,999',
    colors: ['Marble Mist', 'Black Infinity', 'Nexus Blue'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        'Dimensity 8350 Apex processor',
        '12GB next-gen LPDDR5X RAM',
        '256GB ROM',
      ],
      Battery: [
        '7100mAh graphene-reinforced battery',
        'OnePlus\'s biggest battery ever',
        'All-day battery life',
      ],
      Camera: [
        '50MP Sony LYT-600 with OIS',
        '8MP Ultra Wide-angle',
        'Flagship camera system',
      ],
      Display: [
        'AMOLED display',
        '120Hz refresh rate',
        'Ultra HDR support',
        'Dream screen experience',
      ],
      Storage: [
        '8GB RAM + 256GB ROM',
      ],
    },
  },
  {
    id: 3,
    title: 'OnePlus Nord 5 (8GB + 256GB)',
    productImage: onePlusNord5,
    images: [onePlusNord5],
    originalPrice: '34,999',
    discountedPrice: '34,999',
    colors: ['Marble Sand', 'Phantom Black', 'Dry Ice'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        'Snapdragon 8 Series processor',
        'Supercharged DDR5X RAM',
        'Qualcomm-tuned performance',
      ],
      Battery: [
        '6800mAh battery',
        '80W ultra-fast charging',
        'All-day endurance',
      ],
      Camera: [
        '50MP Sony LYT-700 main camera with OIS',
        '8MP Ultra-wide camera',
        '116° field of view',
        '50MP ISOCELL JN5 selfie camera',
      ],
      Display: [
        '144Hz AMOLED display',
        'Aqua Touch support',
        '1400 nits HDR brightness',
      ],
      Storage: [
        '8GB RAM + 256GB ROM',
      ],
    },
  },
  {
    id: 4,
    title: 'OnePlus Nord 5 (12GB + 256GB)',
    productImage: onePlusNord5,
    images: [onePlusNord5],
    originalPrice: '37,999',
    discountedPrice: '37,999',
    colors: ['Marble Sand', 'Phantom Black', 'Dry Ice'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        'Snapdragon 8 Series processor',
        'Supercharged DDR5X RAM',
        'Qualcomm-tuned performance',
      ],
      Battery: [
        '6800mAh battery',
        '80W ultra-fast charging',
        'All-day endurance',
      ],
      Camera: [
        '50MP Sony LYT-700 main camera with OIS',
        '8MP Ultra-wide camera',
        '116° field of view',
        '50MP ISOCELL JN5 selfie camera',
      ],
      Display: [
        '144Hz AMOLED display',
        'Aqua Touch support',
        '1400 nits HDR brightness',
      ],
      Storage: [
        '12GB RAM + 256GB ROM',
      ],
    },
  },
  {
    id: 5,
    title: 'OnePlus 15S (12GB + 256GB)',
    productImage: onePlus15s,
    images: [onePlus15s],
    originalPrice: '54,999',
    discountedPrice: '54,999',
    colors: ['Mint Breeze', 'Charcoal Black', 'Electric Violet'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        "World's first Snapdragon 8 Gen 5",
        'Flagship-level performance',
      ],
      Gaming: [
        'Always-on 120 FPS gaming in MLBB',
        'Silky-smooth and razor-sharp gameplay',
        'High-precision touch response',
      ],
      Battery: [
        '7400mAh battery',
        '80W SUPERVOOC fast charging',
        'Largest-ever OnePlus battery',
      ],
      Camera: [
        '50MP Sony IMX906 main camera',
        'Shake-free OIS',
        '32MP front camera with autofocus',
      ],
      Display: [
        '165Hz smooth display',
        '3200Hz touch response chip',
        'TUV Rheinland Intelligent Eye Care 5.0',
      ],
      Storage: [
        '12GB RAM + 256GB ROM',
      ],
    },
  },
  {
    id: 6,
    title: 'OnePlus 15S (12GB + 512GB)',
    productImage: onePlus15s,
    images: [onePlus15s],
    originalPrice: '59,999',
    discountedPrice: '59,999',
    colors: ['Mint Breeze', 'Charcoal Black', 'Electric Violet'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        "World's first Snapdragon 8 Gen 5",
        'Flagship-level performance',
      ],
      Gaming: [
        'Always-on 120 FPS gaming in MLBB',
        'Silky-smooth and razor-sharp gameplay',
        'High-precision touch response',
      ],
      Battery: [
        '7400mAh battery',
        '80W SUPERVOOC fast charging',
        'Largest-ever OnePlus battery',
      ],
      Camera: [
        '50MP Sony IMX906 main camera',
        'Shake-free OIS',
        '32MP front camera with autofocus',
      ],
      Display: [
        '165Hz smooth display',
        '3200Hz touch response chip',
        'TUV Rheinland Intelligent Eye Care 5.0',
      ],
      Storage: [
        '12GB RAM + 512GB ROM',
      ],
    },
  },
  {
    id: 7,
    title: 'OnePlus 15 (12GB + 256GB)',
    productImage: onePlus15,
    images: [onePlus15],
    originalPrice: '76,999',
    discountedPrice: '76,999',
    colors: ['Sand Storm', 'Infinite Black', 'Ultra Violet'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        'Snapdragon 8 Elite Gen 5 chip',
        'LPDDR5X Ultra+',
        'Supercharged by OP Gaming Core',
      ],
      Gaming: [
        'Always-on stable 120 FPS gaming',
        'Optimized for MLBB and high-frame gameplay',
      ],
      Battery: [
        '7300mAh battery',
        '120W SUPERVOOC charging',
        '50W AIRVOOC charging',
      ],
      Camera: [
        'Periscope telephoto with 3.5x optical zoom',
        '7x optical quality zoom',
        '50MP ultra-wide camera with 112° field of view',
        '50MP wide camera with shake-free OIS',
      ],
      Display: [
        '165Hz silky-smooth display',
        '3200Hz touch response chip',
      ],
      Storage: [
        '12GB RAM + 256GB ROM',
      ],
    },
  },
  {
    id: 8,
    title: 'OnePlus 15 (16GB + 512GB)',
    productImage: onePlus15,
    images: [onePlus15],
    originalPrice: '96,999',
    discountedPrice: '96,999',
    colors: ['Sand Storm', 'Infinite Black', 'Ultra Violet'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Performance: [
        'Snapdragon 8 Elite Gen 5 chip',
        'LPDDR5X Ultra+',
        'Supercharged by OP Gaming Core',
      ],
      Gaming: [
        'Always-on stable 120 FPS gaming',
        'Optimized for MLBB and high-frame gameplay',
      ],
      Battery: [
        '7300mAh battery',
        '120W SUPERVOOC charging',
        '50W AIRVOOC charging',
      ],
      Camera: [
        'Periscope telephoto with 3.5x optical zoom',
        '7x optical quality zoom',
        '50MP ultra-wide camera with 112° field of view',
        '50MP wide camera with shake-free OIS',
      ],
      Display: [
        '165Hz silky-smooth display',
        '3200Hz touch response chip',
      ],
      Storage: [
        '16GB RAM + 512GB ROM',
      ],
    },
  },
  {
    id: 9,
    title: 'OnePlus Pad Go 2 (8GB + 128GB, Wi-Fi Only)',
    productImage: onePlusPadGo2,
    images: [onePlusPadGo2],
    originalPrice: '29,999',
    discountedPrice: '29,999',
    colors: ['Shadow Black', 'Lavender Drift'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Display: [
        '12.1-inch LCD with 7:5 aspect ratio',
        '2.8K (2800 x 1980) resolution',
        '120Hz adaptive refresh rate',
        '900 nits HBM brightness, 284 PPI',
        '98% DCI-P3 color saturation',
        'Eye Comfort technology',
      ],
      Battery: [
        '10050mAh battery capacity',
        '33W SUPERVOOC fast charging',
        'Up to 53 hours music playback',
        'Up to 15 hours video playback',
        'Up to 60 days standby',
        '6.5W reverse wired charging',
      ],
      Performance: [
        'MediaTek Dimensity 7300-Ultra octa-core processor',
        'TUV SUD certified for 48 months smoothness',
        'Supports multitasking with up to 3 app windows',
      ],
      Stylus: [
        'Compatible with OnePlus Stylo',
        '4096 levels of pressure sensitivity',
        'Handwriting recognition',
        'Screen-off note-taking support',
      ],
      Software: [
        'OxygenOS 16 based on Android 14',
        '3 years of major Android updates',
        '4 years of security patches',
      ],
      Connectivity: [
        'Dual-band Wi-Fi support',
      ],
      Storage: [
        '8GB RAM + 128GB ROM (Wi-Fi Only)',
      ],
    },
  },
  {
    id: 10,
    title: 'OnePlus Pad Go 2 (8GB + 256GB, Wi-Fi Only)',
    productImage: onePlusPadGo2,
    images: [onePlusPadGo2],
    originalPrice: '32,999',
    discountedPrice: '32,999',
    colors: ['Shadow Black', 'Lavender Drift'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Display: [
        '12.1-inch LCD with 7:5 aspect ratio',
        '2.8K (2800 x 1980) resolution',
        '120Hz adaptive refresh rate',
        '900 nits HBM brightness, 284 PPI',
        '98% DCI-P3 color saturation',
        'Eye Comfort technology',
      ],
      Battery: [
        '10050mAh battery capacity',
        '33W SUPERVOOC fast charging',
        'Up to 53 hours music playback',
        'Up to 15 hours video playback',
        'Up to 60 days standby',
        '6.5W reverse wired charging',
      ],
      Performance: [
        'MediaTek Dimensity 7300-Ultra octa-core processor',
        'TUV SUD certified for 48 months smoothness',
        'Supports multitasking with up to 3 app windows',
      ],
      Stylus: [
        'Compatible with OnePlus Stylo',
        '4096 levels of pressure sensitivity',
        'Handwriting recognition',
        'Screen-off note-taking support',
      ],
      Software: [
        'OxygenOS 16 based on Android 14',
        '3 years of major Android updates',
        '4 years of security patches',
      ],
      Connectivity: [
        'Dual-band Wi-Fi support',
      ],
      Storage: [
        '8GB RAM + 256GB ROM (Wi-Fi Only)',
      ],
    },
  },
  {
    id: 11,
    title: 'OnePlus Pad Go 2 (8GB + 256GB, Wi-Fi + Cellular)',
    productImage: onePlusPadGo2,
    images: [onePlusPadGo2],
    originalPrice: '35,999',
    discountedPrice: '35,999',
    colors: ['Shadow Black', 'Lavender Drift'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Display: [
        '12.1-inch LCD with 7:5 aspect ratio',
        '2.8K (2800 x 1980) resolution',
        '120Hz adaptive refresh rate',
        '900 nits HBM brightness, 284 PPI',
        '98% DCI-P3 color saturation',
        'Eye Comfort technology',
      ],
      Battery: [
        '10050mAh battery capacity',
        '33W SUPERVOOC fast charging',
        'Up to 53 hours music playback',
        'Up to 15 hours video playback',
        'Up to 60 days standby',
        '6.5W reverse wired charging',
      ],
      Performance: [
        'MediaTek Dimensity 7300-Ultra octa-core processor',
        'TUV SUD certified for 48 months smoothness',
        'Supports multitasking with up to 3 app windows',
      ],
      Stylus: [
        'Compatible with OnePlus Stylo',
        '4096 levels of pressure sensitivity',
        'Handwriting recognition',
        'Screen-off note-taking support',
      ],
      Software: [
        'OxygenOS 16 based on Android 14',
        '3 years of major Android updates',
        '4 years of security patches',
      ],
      Connectivity: [
        'Dual-band Wi-Fi support',
        '5G connectivity support (cellular variant)',
      ],
      Storage: [
        '8GB RAM + 256GB ROM (Wi-Fi + Cellular)',
      ],
    },
  },
  {
    id: 12,
    title: 'OnePlus Pad Lite (6GB + 128GB, Wi-Fi Only)',
    productImage: onePlusPadLite,
    images: [onePlusPadLite],
    originalPrice: '19,999',
    discountedPrice: '19,999',
    colors: ['Aero Blue'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Display: [
        '11-inch LCD with 16:10 aspect ratio',
        '1920 x 1200 resolution',
        'Adaptive 60Hz/90Hz refresh rate',
        '500 nits brightness',
        '10-bit color depth (8+2)',
        '70.8% NTSC color gamut',
        'Eye Comfort technology',
      ],
      Battery: [
        '9340mAh typical capacity / 9098mAh rated',
        '33W SUPERVOOC fast charging',
        'Optimized for long playback and standby',
      ],
      Performance: [
        'MediaTek Helio G100 platform',
        'Certified for 36 months of lasting smoothness',
        'Open Canvas split-screen multitasking support',
      ],
      Stylus: [
        'Compatible with OnePlus Stylo',
        'Built for note-taking and creative tasks',
      ],
      Software: [
        'OxygenOS 15.0.1 based on Android 14',
        '3 years of major Android updates',
        '4 years of security patches',
      ],
      Connectivity: [
        'Wi-Fi 5 (802.11ac) support',
      ],
      Audio: [
        'Hi-Res Audio certified quad speakers',
        'Bluetooth 5.4 support',
        'SBC, AAC, aptX, aptX HD, LDAC codecs',
      ],
      Camera: [
        '5MP rear camera',
        'Rear video: 1080p/720p at 30fps',
        '5MP front camera',
        'Facial recognition unlock',
      ],
      'Kids Mode': [
        'Child-friendly interface',
        'Parental controls',
        'Default Eye Care protection',
      ],
      Storage: [
        '6GB RAM + 128GB ROM (Wi-Fi Only)',
      ],
    },
  },
  {
    id: 13,
    title: 'OnePlus Pad Lite (8GB + 128GB, Wi-Fi + Cellular)',
    productImage: onePlusPadLite,
    images: [onePlusPadLite],
    originalPrice: '24,999',
    discountedPrice: '24,999',
    colors: ['Aero Blue'],
    offers: [
      { label: 'Offer', value: '(Inclusive of credit card offers)' },
    ],
    specifications: {
      Display: [
        '11-inch LCD with 16:10 aspect ratio',
        '1920 x 1200 resolution',
        'Adaptive 60Hz/90Hz refresh rate',
        '500 nits brightness',
        '10-bit color depth (8+2)',
        '70.8% NTSC color gamut',
        'Eye Comfort technology',
      ],
      Battery: [
        '9340mAh typical capacity / 9098mAh rated',
        '33W SUPERVOOC fast charging',
        'Optimized for long playback and standby',
      ],
      Performance: [
        'MediaTek Helio G100 platform',
        'Certified for 36 months of lasting smoothness',
        'Open Canvas split-screen multitasking support',
      ],
      Stylus: [
        'Compatible with OnePlus Stylo',
        'Built for note-taking and creative tasks',
      ],
      Software: [
        'OxygenOS 15.0.1 based on Android 14',
        '3 years of major Android updates',
        '4 years of security patches',
      ],
      Connectivity: [
        'Wi-Fi 5 (802.11ac) support',
        '4G LTE support (no 5G)',
      ],
      Audio: [
        'Hi-Res Audio certified quad speakers',
        'Bluetooth 5.4 support',
        'SBC, AAC, aptX, aptX HD, LDAC codecs',
      ],
      Camera: [
        '5MP rear camera',
        'Rear video: 1080p/720p at 30fps',
        '5MP front camera',
        'Facial recognition unlock',
      ],
      'Kids Mode': [
        'Child-friendly interface',
        'Parental controls',
        'Default Eye Care protection',
      ],
      Storage: [
        '8GB RAM + 128GB ROM (Wi-Fi + Cellular)',
      ],
    },
  },
];

export default onePlusData;
